import { apiUrl } from '@/api/axios';
import { handleResponseError } from '@/core/utils/handleResponseError';

export const fetchData = (slice: any, url: any) => (id?: number | null) => async (dispatch: any, getState: any) => {
    dispatch(slice.actions.fetchDataStart());

    try {
        const requestUrl = id ? `${url}${id}` : url;
        const response = await apiUrl.get(requestUrl);

        const data = response.data.data;
        // console.log('Data fetched successfully:', data);

        dispatch(slice.actions.setDataLoaded(data));
    } catch (error) {
        console.error('Error during data fetch:', error);
        handleResponseError(error, (errorMessage, isNetworkError) => {
            dispatch(slice.actions.fetchDataError({ errorMessage, isNetworkError }));
        });
    }
};